module.exports = __webpack_public_path__ + "img/K.d0a1245c.jpg";